@if (resAsync | async) {
  <p
    [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'"
    [ngClass]="frame?.rtlEnabled ? 'works_HeadLine_vague_rtl' : 'works_HeadLine_vague'"
    [ngClass.xs]="'works_HeadLineXS_vague'"
  >
    @if (ticketNavigationContext?.ticket?.object?.designation) {
      <mark class="works_HeadLineMark">{{ res.get('Ticket-Object') }}</mark>
    }
    {{ ticketNavigationContext?.ticket?.object?.designation }}
    @if (ticketNavigationContext?.ticket?.object?.street) {
      <mark class="works_HeadLineMark">
        {{ res.get('Works-Task-Detail-Street') }}
      </mark>
    }
    {{ ticketNavigationContext?.ticket?.object?.street }}
  </p>
}
<div [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'" class="detailPage_Navigation_Buttons" fxLayout="row">
  <ticket-navigation></ticket-navigation>
  <div class="task_HeadLine">
    <mark class="works_HeadLineMark ticketTextPadding">{{ res.get('Ticket-Number') }}</mark>
    <span>{{ ticketNavigationContext?.ticket?.number + ', ' + ticketNavigationContext?.ticket?.designation }}</span>
    <div fxLayout="row" fxLayout="row wrap" fxLayoutGap="10px">
      <button
        mat-button
        class="navigationActionButton"
        [ngStyle]="{ display: !this.frame.mapInfo.isReadOnly ? 'inline' : 'none' }"
        [disabled]="!this.needForPersistence"
        (click)="this.save()"
      >
        <mat-icon [svgIcon]="res.svgName('Save-Image')"></mat-icon>
      </button>
      <button
        mat-button
        class="navigationActionButton"
        [ngStyle]="{ display: !this.frame.mapInfo.isReadOnly ? 'inline' : 'none' }"
        [disabled]="!this.needForPersistence"
        (click)="this.revert()"
      >
        <mat-icon [svgIcon]="res.svgName('Cancel-Image')"></mat-icon>
      </button>
      @if (allowDeletion) {
        <button
          mat-button
          class="navigationActionButton"
          [ngStyle]="{ display: !this.frame.mapInfo.isReadOnly ? 'inline' : 'none' }"
          (click)="this.delete()"
        >
          <mat-icon [svgIcon]="res.svgName('Delete-Image')"></mat-icon>
        </button>
      }
      <text class="works_isReadOnly" [ngStyle]="{ display: this.frame.mapInfo.isReadOnly ? 'inline' : 'none' }">
        <div>{{ res.get('Works-Task-Detail-ReadOnlyMessage') }}</div>
      </text>
    </div>
  </div>
</div>
<div
  id="scrollArea"
  class="scollDiv"
  [dir]="frame.rtlEnabled ? 'rtl' : 'auto'"
  id="scrollArea"
  style="overflow-y: auto"
>
  <mat-vertical-stepper #stepper>
    <ng-template matStepperIcon="done" let-index="index">
      <mat-icon [svgIcon]="res.svgName('Done-Image')"></mat-icon>
    </ng-template>
    <ng-template matStepperIcon="edit" let-index="index">
      {{ index + 1 }}
    </ng-template>
    <ng-template matStepperIcon="default" let-index="index">
      {{ index + 1 }}
    </ng-template>
    @for (task of ticketNavigationContext?.ticket?.ticketTasks; track trackById(i, task); let i = $index) {
      <mat-step [label]="task.designation" [state]="task.finished ? 'done' : 'default'" [completed]="task.finished">
        <div fxLayout="row" fxLayout.xs="column">
          <div fxFlex="50">
            <div fxLayout="column">
              <div fxLayout="row">
                <abc-drop-down-box
                  [arrayDataConfig]="arrayDataConfig"
                  [(value)]="task.state"
                  [labelMode]="'floating'"
                  [label]="'Status'"
                  [placeholder]="'Status'"
                  [stylingMode]="'underlined'"
                  [validationStatus]="'valid'"
                  [ngStyle]="{ width: '230px' }"
                  [ngStyle.xs]="{ width: '295px' }"
                >
                </abc-drop-down-box>
                <!-- Hidden for now -->
                <!-- <button mat-icon-button [disabled]="!task.resource" (click)="this.sendNotification(task)">
                  <mat-icon [svgIcon]="res.svgName('Send-Image')"></mat-icon>
                </button> -->
              </div>
              <div fxLayout="row" style="padding-top: 20px; padding-bottom: 10px">
                <div fxFlex="100">
                  <div
                    fxLayout="row"
                    fxLayout.xs="column"
                    fxLayout.sm="column"
                    fxLayout.md="column"
                    class="detailContainer"
                  >
                    <div fxFlex="40">
                      <abc-date-box
                        [(value)]="task.startDate"
                        [acceptCustomValue]="'true'"
                        [cancelButtonText]="'Cancel'"
                        [labelMode]="'floating'"
                        [label]="'Datum - Start'"
                        [placeholder]="'Datum - Start'"
                        [stylingMode]="'underlined'"
                        [type]="'date'"
                        [validationMessageMode]="'auto'"
                        [validationStatus]="'valid'"
                        [valueChangeEvent]="'change'"
                        [ngStyle]="{ width: '230px' }"
                        [ngStyle.xs]="{ width: '295px' }"
                      >
                      </abc-date-box>
                    </div>
                    <div fxFlex="40">
                      <abc-date-box
                        [(value)]="task.startTime"
                        [labelMode]="'floating'"
                        [label]="'Uhrzeit - Start'"
                        [pickerType]="'list'"
                        [placeholder]="'Uhrzeit - Start'"
                        [stylingMode]="'underlined'"
                        [type]="'time'"
                        [ngStyle]="{ width: '230px' }"
                        [ngStyle.xs]="{ width: '295px' }"
                      >
                      </abc-date-box>
                    </div>
                  </div>
                  <div
                    fxLayout="row"
                    fxLayout.xs="column"
                    fxLayout.sm="column"
                    fxLayout.md="column"
                    class="endContainer"
                  >
                    <div fxFlex="40">
                      <abc-date-box
                        [(value)]="task.endDate"
                        [cancelButtonText]="'Cancel'"
                        [labelMode]="'floating'"
                        [label]="'Datum - Ende'"
                        [placeholder]="'Datum - Ende'"
                        [stylingMode]="'underlined'"
                        [type]="'date'"
                        [validationMessageMode]="'auto'"
                        [validationStatus]="'valid'"
                        [ngStyle]="{ width: '230px' }"
                        [ngStyle.xs]="{ width: '295px' }"
                      >
                      </abc-date-box>
                    </div>
                    <div fxFlex="40">
                      <abc-date-box
                        [(value)]="task.endTime"
                        [labelMode]="'floating'"
                        [label]="'Uhrzeit - Ende'"
                        [placeholder]="'Uhrzeit - Ende'"
                        [stylingMode]="'underlined'"
                        [type]="'time'"
                        [ngStyle]="{ width: '230px' }"
                        [ngStyle.xs]="{ width: '295px' }"
                      >
                      </abc-date-box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div fxFlex="50">
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" animationDuration="0ms" class="tab-group">
              <mat-tab label="Kommentare">
                <table class="taskDetail_Table">
                  <tr>
                    <td>
                      <abc-common-editors-comments-list
                        class="commentList"
                        [identifier]="Standard"
                        [isReadOnly]="false"
                        [comments]="task.comments"
                        [parentInfo]="{ id: task.id, objectType: task.objectType }"
                      >
                      </abc-common-editors-comments-list>
                    </td>
                  </tr>
                </table>
              </mat-tab>
              <mat-tab label="Fotos">
                <div style="padding-top: 30px; display: flex; justify-content: center; align-items: center">
                  <abc-media-gallery
                    (onDataChanged)="mediaGalleryDataChanged($event, task)"
                    [dataSource]="getMediaDocuments(task)"
                  >
                  </abc-media-gallery>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </mat-step>
    }
  </mat-vertical-stepper>
</div>
